import React from 'react';
import { Route, Switch } from 'react-router';
import { Close } from 'grommet-icons';
import Search from './pages/Search';
import Video from './pages/Video';
import Layout from './components/Layout';

interface IAppProps {
}

interface IAppState {
}

export default class App extends React.PureComponent<IAppProps, IAppState> {
  public render() {
    return <Layout>
      <Switch>
        <Route exact path='/' component={Search} />
        <Route exact path='/us/en/' component={Search} />
        <Route path='/us/en/:category/category' component={Search} />
        <Route path='/us/en/:channel?/:category?/:subcategory?/:id/:title/video/:max?' component={Video} />
        <Route path='/us/en/:id/:title?/video/:max?' component={Video} />
        <Route path='/us/en/:trackId/:lang/:country/:id/:title/video/:max?' component={Video} />
        <Route path='/error' component={() => {
          window.location.href = 'https://www.hpe.com/us/en/errorpages/404.html';
          return null;
        }} />
      </Switch>
    </Layout>;
  }
};
